import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from '../../buttons/Button';

import { setPickerStore, storeDetectionError } from '../../../redux/actions/pickerStore.actions';

import { padTo8LeadingZeroes } from '../../../utils';
import { MANUAL_STORE_SELECTION } from '../../../constants';

import styles from './StoreVerification.css';

type Props = {
  storeToVerify: string | null;
};

const StoreVerification = ({ storeToVerify }: Props): ReactElement => {
  const { t } = useTranslation();
  const translationRoot = 'STORE_VERIFICATION';
  const dispatch = useDispatch();

  return (
    <section className={styles.section}>
      <p className={styles.p} data-cy="store-verification-p">
        {t(`${translationRoot}.VERIFY`, {
          storeToVerify,
        })}
      </p>
      <Button
        className={styles.button}
        data-cy="store-verification-confirm-button"
        onClick={() => {
          if (storeToVerify) {
            const paddedStoreID = padTo8LeadingZeroes(storeToVerify);

            // Persist confirmed store as manual selection
            sessionStorage.setItem(MANUAL_STORE_SELECTION, paddedStoreID);

            dispatch(setPickerStore({ storeID: paddedStoreID }));
          }
        }}
      >
        {t(`${translationRoot}.CONFIRM`)}
      </Button>
      <Button
        className={styles.button}
        data-cy="store-verification-cancel-button"
        color="secondary"
        onClick={() => dispatch(storeDetectionError())}
      >
        {t(`${translationRoot}.CANCEL`)}
      </Button>
    </section>
  );
};

export default StoreVerification;
